import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { FiWrapperTableAdditionalColumns } from '@fi-shared/fi-wrapper-table/fi-wrapper-table-additional-columns';

@Component({
    selector: 'fi-checklist2-list-checkpoints-count',
    templateUrl: './fi-checklist2-list-checkpoints-count.component.html',
    styleUrls: ['./fi-checklist2-list-checkpoints-count.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-checklist2-list-changed-on' },
    providers: [{ provide: FiWrapperTableAdditionalColumns, useExisting: FiChecklist2ListCheckpointsCountComponent }],
    standalone: false,
})
export class FiChecklist2ListCheckpointsCountComponent extends FiWrapperTableAdditionalColumns {}
